import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

@Composable
internal fun TourPresentationTable(
    entries: List<TourEntryDto>, placements: List<TourDrawEntryDto>, handicaps: List<TourHandicapDto>,
    players: List<TourPlayerDto>, jokerUses: List<TourJokerUseDto>, discipline: String, disabled: Boolean,
    onAttendance: (TourEntryDto, String) -> Unit, onJoker: (TourEntryDto, Boolean) -> Unit,
) {
    val positions = placements.associateBy { it.entryId }
    val names = players.associate { it.id to (it.fullName?.takeIf { name -> name.isNotBlank() } ?: it.name) }
    val assignments = handicaps.associateBy { it.playerId }
    val jokers = jokerUses.associateBy { it.playerId }
    val groups = entries.sortedWith(compareBy<TourEntryDto> { positions[it.id]?.lane ?: Int.MAX_VALUE }
        .thenBy { positions[it.id]?.position ?: Int.MAX_VALUE }.thenBy(tourNameComparator) { it.playerName })
        .groupBy { positions[it.id]?.lane }
    Div(attrs = { classes("table-scroll") }) {
        Table(attrs = { classes("tour-admin-table", "tour-presentation-table"); attr("aria-label", "Prezentace podle drah") }) {
            Thead { Tr { listOf("Pozice", "Hráč", "Prezentace", "Žolík", "Skupina / HDCP").forEach { Th { Text(it) } } } }
            groups.forEach { (lane, playersOnLane) -> Tbody {
                Tr(attrs = { classes("tour-lane-heading") }) { Th(attrs = { colspan(5); attr("scope", "rowgroup") }) { Text(lane?.let { "Dráha $it" } ?: "Bez vylosované dráhy") } }
                playersOnLane.forEach { e -> Tr(attrs = { attr("data-presentation-entry", e.id) }) {
                    Td { Text(positions[e.id]?.position?.toString() ?: "—") }
                    Td(attrs = { classes("tour-player-name") }) {
                        Span(attrs = { if (e.attendance == "absent") classes("tour-absent-player") }) { Text(names[e.playerId] ?: e.playerName) }
                        positions[e.id]?.movedFromLane?.let { lane ->
                            Div(attrs = { classes("muted") }) { Text("Přesun z dráhy $lane · pozice ${positions[e.id]?.movedFromPosition}") }
                        }
                    }
                    Td { Div(attrs = { classes("tour-table-actions") }) {
                        Button(attrs = {
                            if (e.attendance == "present") classes("primary")
                            attr("aria-label", if (e.attendance == "present") "Zrušit prezentaci ${e.playerName}" else "Prezentovat ${e.playerName}")
                            attr("aria-pressed", (e.attendance == "present").toString())
                            if (disabled) disabled()
                            onClick { onAttendance(e, if (e.attendance == "present") "registered" else "present") }
                        }) { Text(if (e.attendance == "present") "Prezentován ✓" else "Prezentovat") }
                        if (e.attendance != "present") {
                            if (e.attendance == "absent") Span(attrs = { classes("muted") }) { Text("Nepřišel") }
                            else Button(attrs = { attr("aria-label", "Neúčast ${e.playerName}"); if (disabled) disabled(); onClick { onAttendance(e, "absent") } }) { Text("Nepřišel") }
                        }
                    } }
                    Td {
                        val usedElsewhere = jokers[e.playerId]?.entryId?.let { it != e.id } == true
                        if (usedElsewhere) Span(attrs = { classes("muted"); title("Žolík již použit v jiném turnaji tohoto ročníku") }) { Text("Vyčerpán") }
                        else Label {
                            Input(type = InputType.Checkbox) {
                                attr("aria-label", "Žolík ${e.playerName}"); checked(e.joker)
                                if (disabled || e.attendance != "present") disabled()
                                onChange { onJoker(e, it.value) }
                            }
                            Text("Žolík")
                        }
                    }
                    Td {
                        val group = if (e.handicapFrozenAt != null) e.handicapGroup else assignments[e.playerId]?.groupCode
                        val hdcp = if (e.handicapFrozenAt != null) e.handicap else tourHandicapValue(group, discipline)
                        Text(group?.let { "$it / $hdcp" } ?: "Čeká na přiřazení")
                    }
                } }
            } }
        }
    }
    if (entries.isEmpty()) P { Text("V této rundě nejsou přihlášení hráči.") }
}
